// we want to check line numbers (in test builds)
// so keep this file small
import React from 'react'
import {Part} from 'uix/parts'
import {Actions} from 'uix/registries'
import log from 'uix/logging'

// ---Local imports
import {triggerSagaError} from './actions'

// ---Exports
export class TestErrorDuringRender extends Part {
  static storeMap = ['meta.user.session', 'meta.request']
  static actionMap = {triggerSagaError, callApi: Actions.callApi, reduceApi: Actions.reduceApi}
  static dispatchActions = true

  _render() {
    let {request, go, callApi, reduceApi, session, dispatch} = this.props
    if (request.query.triggerRenderError) {
      throw Error('something bad happened')
    }

    if (request.query.logExceptionInRender) {
      try {
        throw Error('something bad happened')
      } catch (e) {
        log.exception('something bad', e)
      }
    }

    let Trigger = ({s, f}) => (
      <div>
        <input style={{width: 160}} type="button" onClick={f} value={s} />
      </div>
    )

    let logException = () => {
      try {
        UNDECLARED
      } catch (e) {
        log.exception('logged exception: %o %O', 'why?', e)
      }
    }

    return (
      <>
        <Trigger s="filter error" f={() => go({query: {triggerFilterError: true}})} />
        <Trigger s="render error" f={() => go({query: {triggerRenderError: true}})} />
        <Trigger s="saga error" f={() => this.props.triggerSagaError()} />
        <Trigger s="reducer error" f={() => dispatch({type: 'TEST_ERROR_THROW'})} />
        <Trigger s="reducer mutation" f={() => dispatch({type: 'TEST_ERROR_MUTATE'})} />
        <Trigger s="log exception (click)" f={logException} />
        <Trigger s="log exception (render)" f={() => go({query: {logExceptionInRender: true}})} />
        <Trigger s="delete session" f={() => callApi('deleteSession', {id: session})} />
      </>
    )
  }
}
